/* global locale */

const namespaced = true

const state = {
  checkInDate: null,
  checkOutDate: null,
  contractedCheckInDate: null,
  contractedCheckOutDate: null,
  contractedOnlyMap: false,
  destination: '',
  eventLatitude: null,
  eventLongitude: null,
  excludedHotels: [],
  filteredHotels: [],
  hotel: null,
  hotels: [],
  hotelRooms: [],
  latitude: null,
  loading: false,
  longitude: null,
  hasFilterResults: null,
  packageId: null,
  pageCount: 10,
  retailHotels: [],
  retailLoading: false,
  roomQty: 1,
  scrollPosition: null,
  searchLatitude: null,
  searchLongitude: null,
  showFilter: false,
  showRetailIndex: false,
  showMap: false,
  totalHotels:[],
  venue: null,
  wasOnMap: false,
  temp: []
}

const mutations = {
  increaseRoomQty(state, n) {
    state.roomQty += n
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setRetailLoading(state, retailLoading) {
    state.retailLoading = retailLoading
  },
  updateVenue(state, venue) {
    state.venue = venue
  },
  updateDestination(state, destination) {
    state.destination = destination
  },
  updateLatitude(state, eventLatitude) {
    state.eventLatitude = eventLatitude
  },
  updateLongitude(state, eventLongitude) {
    state.eventLongitude = eventLongitude
  },
  updateSearchLat(state, searchLatitude) {
    state.searchLatitude = searchLatitude
  },
  updateSearchLng(state, searchLongitude) {
    state.searchLongitude = searchLongitude
  },
  updateCheckInDate(state, checkInDate) {
    state.checkInDate = checkInDate
  },
  updateCheckOutDate(state, checkOutDate) {
    state.checkOutDate = checkOutDate
  },
  updateContractedCheckInDate(state, checkInDate) {
    state.contractedCheckInDate = checkInDate
  },
  updateContractedCheckOutDate(state, checkOutDate) {
    state.contractedCheckOutDate = checkOutDate
  },
  updateRoomQty(state, n) {
    state.roomQty = n
  },
  setTotalHotels(state, hotels){
    state.totalHotels = hotels
  },
  updateHotelsArray(state, hotels) {
    state.filteredHotels = []
    state.hotels.push(...hotels)
  },
  increasePageCount(state, count) {
    state.pageCount += count
  },
  reloadRetailHotels(state) {
    state.retailHotels = state.hotels.filter(hotel => hotel.contracted == false)
  },
  populateExcludedHotels(state, hotel) {
    state.excludedHotels.push(hotel)
  },
  clearExcludedHotels(state) {
    state.excludedHotels = []
  },
  populateFilteredHotels(state) {
    state.filteredHotels = state.retailHotels
  },
  setFilteredHotels(state) {
    state.excludedHotels.forEach((hotel) => {
      for(let i= 0; i < state.filteredHotels.length; i++) {
        hotel.id === state.filteredHotels[i].id ? state.filteredHotels.splice(i, 1) : ''
      }
    })
  },
  sortHotelsByDistance(state) {
    if(state.filteredHotels.length > 0) {
      return state.filteredHotels = state.filteredHotels.sort((a, b) => a.directions.distance.value > b.directions.distance.value ? 1 : -1)
    } else if(state.filteredHotels.length == 0) {
      return state.filteredHotels = state.hotels.filter(hotel => hotel.contracted == false).sort((a, b) => a.directions.distance.value > b.directions.distance.value ? 1 : -1)
    } else {
      return
    }
  },
  sortHotelsByPrice(state) {
    if(state.filteredHotels.length > 0) {
      return state.filteredHotels = state.filteredHotels.sort((a, b) => (Number.parseFloat(a.rooms[0].total) > Number.parseFloat(b.rooms[0].total)) ? 1: -1)
    } else if(state.filteredHotels.length == 0) {
      return state.filteredHotels = state.hotels.sort((a, b) => (Number.parseFloat(a.rooms[0].total) > Number.parseFloat(b.rooms[0].total)) ? 1: -1)
    } else {
      return
    }
  },
  hasHotelResults(state){
    state.excludedHotels = Array.from(new Set(state.excludedHotels))
    if(state.excludedHotels.length !== state.retailHotels.length) {
      return state.hasFilterResults = true
    } else {
      return state.hasFilterResults = false
    }
  },
  clearNonContractedHotels(state) {
    state.hotels = state.hotels.filter(hotel => hotel.contracted == true)
  },
  addHotelToArray(state, hotel) {
    state.hotels.push(hotel)
  },
  selectHotel(state, hotel) {
    if (state.showMap) {
      state.wasOnMap = true
      state.showMap = false
    }
    state.scrollPosition = window.scrollY
    window.scrollTo({top: 0, behavior: 'smooth'})

    state.hotel = hotel
  },
  deselectHotel(state) {
    if (state.wasOnMap) {
      state.showMap = true
      state.wasOnMap = false
    }
    window.scrollTo({top: state.scrollPosition, behavior: 'smooth'})
    state.hotel = null
  },
  showRetailIndex(state, showRetailIndex) {
    state.showRetailIndex = showRetailIndex
  },
  showMap(state, showMap) {
    if (showMap) {
      state.scrollPosition = window.scrollY
    }
    if (!showMap) {
      state.contractedOnlyMap = false
      setTimeout(() => {
        window.scrollTo({top: state.scrollPosition, behavior: 'smooth'})
      }, 300)
    }
    state.showMap = showMap
  },
  setContractedOnlyMap(state, contractedOnly) {
    state.contractedOnlyMap = contractedOnly
  },
  toggleFilter(state) {
    state.showFilter == true ? state.showFilter = false : state.showFilter = true
  }
}


const getters = {
  getContractedHotels: state => {
    return state.hotels.filter(hotel => hotel.contracted == true)
  },
  getRetailHotels: state => {
    state.retailHotels = state.hotels.filter(hotel => hotel.contracted == false).slice(0, state.pageCount)
    return state.retailHotels
  },
  getFilteredHotels: state => {
    return state.filteredHotels
  },
  sendCheckInToArn: state => {
    if (!state.checkInDate) return
    return state.checkInDate.toISOString().slice(0,10)
  },
  sendCheckOutToArn: state => {
    if (!state.checkOutDate) return
    return state.checkOutDate.toISOString().slice(0,10)
  },
  getCheckInDate: state => {
    return new Date(state.checkInDate).toLocaleDateString(locale,
      {month: 'numeric', day: 'numeric', year: 'numeric'})
  },
  getCheckOutDate: state => {
    return new Date(state.checkOutDate).toLocaleDateString(locale,
      {month: 'numeric', day: 'numeric', year: 'numeric'})
  },
  getContractedCheckInDate: state => {
    return new Date(state.contractedCheckInDate).toLocaleDateString(locale,
      {month: 'numeric', day: 'numeric', year: 'numeric'})
  },
  getContractedCheckOutDate: state => {
    return new Date(state.contractedCheckOutDate).toLocaleDateString(locale,
      {month: 'numeric', day: 'numeric', year: 'numeric'})
  },
  getLowestValue: state => hotelId => {
    const hotel = state.hotels.find(x => x.id === hotelId)
    if (!hotel || hotel == []) {
      return
    }

    return hotel.rooms[0].total
  },
  getContractedNightCount: state => {
    const checkin = new Date(state.contractedCheckInDate)
    const checkout = new Date(state.contractedCheckOutDate)
    return checkout.getDate() - checkin.getDate()

  },
  getRetailNightCount: state => {
    const checkin = new Date(state.checkInDate)
    const checkout = new Date(state.checkOutDate)
    return checkout.getDate() - checkin.getDate()

  },
}

export default {
  namespaced,
  state,
  getters,
  mutations
}
